import { Tooltip } from '@chakra-ui/react';
import React from 'react';
const ConditionalTooltip = ({ condition, children, ...rest }) => {
    if (!condition)
        return children;
    return (React.createElement(Tooltip, { role: "tooltip", "data-testid": "conditional_tooltip", placement: "bottom", hasArrow: true, ...rest }, children));
};
export default ConditionalTooltip;
